import React, { useState } from 'react';
import { useDropzone } from 'react-dropzone';
import axios from 'axios';

const FileUploader = () => {
    const [selectedFile, setSelectedFile] = useState(null);
    const [fileName, setFileName] = useState('');
    const [monthYear, setMonthYear] = useState('');
    const [isUploading, setIsUploading] = useState(false);
    const [uploadStatus, setUploadStatus] = useState('');

    const fileOptions = [
        'PONTO_FUNCHAL NEGOCIOS E EMPREENDIMENTOS LTDA_MMAAAA',
        'PONTO_FUNCHAL PARTICIPACOES E EMPREENDIMENTOS LTDA_MMAAAA',
        'PONTO_TATTINI SOCIEDADE DE ADVOGADOS_MMAAAA'
    ];

    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        accept: {
            'text/plain': ['.txt']
        },
        maxFiles: 1,
        onDrop: acceptedFiles => {
            setSelectedFile(acceptedFiles[0]);
        }
    });

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!selectedFile || !fileName || !monthYear) {
            setUploadStatus('Preencha todos os campos');
            return;
        }

        const formattedFileName = fileName.replace('MMAAAA', monthYear.replace('/', ''));
        const formData = new FormData();
        formData.append('file', selectedFile);
        formData.append('payload', JSON.stringify({
            'nome_arquivo_remoto': formattedFileName
        }));

        try {
            setIsUploading(true);
            setUploadStatus('Enviando...');

            const response = await axios.post('https://funchal-backend.33gn6t.easypanel.host/upload', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });

            setUploadStatus('Upload realizado com sucesso!');
            console.log(response.data);
        } catch (error) {
            setUploadStatus('Erro no upload: ' + error.message);
            console.error(error);
        } finally {
            setIsUploading(false);
        }
    };

    return (
        <div className="file-uploader">
            <h2>Upload de Arquivos</h2>
            <form onSubmit={handleSubmit}>
                <div className="form-group">
                    <label>Nome do Arquivo:</label>
                    <select
                        value={fileName}
                        onChange={(e) => setFileName(e.target.value)}
                        required
                    >
                        <option value="">Selecione uma opção</option>
                        {fileOptions.map((option, index) => (
                            <option key={index} value={option}>{option}</option>
                        ))}
                    </select>
                </div>

                <div className="form-group">
                    <label>Mês/Ano (MMAAAA):</label>
                    <input
                        type="text"
                        placeholder="Ex: 042025"
                        value={monthYear}
                        onChange={(e) => setMonthYear(e.target.value)}
                        pattern="\d{6}"
                        title="Digite o mês e ano no formato MMAAAA"
                        required
                    />
                </div>

                <div {...getRootProps()} className={`dropzone ${isDragActive ? 'active' : ''}`}>
                    <input {...getInputProps()} />
                    {isDragActive ? (
                        <p>Solte o arquivo aqui...</p>
                    ) : (
                        <p>Arraste e solte um arquivo aqui, ou clique para selecionar</p>
                    )}
                    {selectedFile && (
                        <div className="file-info">
                            <p>Arquivo selecionado: {selectedFile.name}</p>
                        </div>
                    )}
                </div>

                <button type="submit" disabled={isUploading}>
                    {isUploading ? 'Enviando...' : 'Enviar Arquivo'}
                </button>

                {uploadStatus && <p className="status">{uploadStatus}</p>}
            </form>
        </div>
    );
};

export default FileUploader;
